const AddEmployeeActionType = {
	/** ****************************** ADD EMPLOYEE *********************** */
	ADD_EMPLOYEE_START: 'add_employee_start',
	ADD_EMPLOYEE_SUCCESS: 'add_employee_success',
	ADD_EMPLOYEE_FAILURE: 'add_employee_failure',
	ADD_EMPLOYEE_RESPONSE_CHANGED: 'add_employee_response_changed',
	ADD_EMPLOYEE_RESPONSE_REST_START: 'add_employee_response_rest_start',
	ADD_EMPLOYEE_KEY: 'AddEmployeeDetailsFromWeb',
	/** ****************************** GET EMPLOYEE NAME AND ID *********************** */
	GET_EMPLOYEE_NAME_AND_ID_START: 'get_employee_name_and_id_start',
	GET_EMPLOYEE_NAME_AND_ID_SUCCESS: 'get_employee_name_and_id_success',
	GET_EMPLOYEE_NAME_AND_ID_FAILURE: 'get_employee_name_and_id_failure',
	GET_EMPLOYEE_NAME_AND_ID_RESPONSE_CHANGED: 'get_employee_name_and_id_response_changed',
	GET_EMPLOYEE_NAME_AND_ID_RESPONSE_REST_START: 'get_employee_name_and_id_response_rest_start',
};

export default AddEmployeeActionType;
